import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/topic/exam"

const topicExam = {
  topicExamListPage(pageSize, limit, keyWord) {
    return axios.get(pre + `/topicExamListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord
        }
    });
  },

  topicExamInfo(id) {
    return axios.get(pre + `/topicExamInfo`, {params: {id: id}});
  },
  topicExamSave(params) {
    return axios.post(pre + `/topicExamSave`, qs.stringify(params));
  },
  topicExamUpdateSort(id, sort) {
    return axios.post(pre + `/topicExamUpdateSort`, qs.stringify({
      id: id,
      sort: sort,
    }));
  },

  topicExamDelete(id) {
    return axios.delete(pre + `/topicExamDelete`, {params: {id: id}});
  },
}
export default topicExam;



// WEBPACK FOOTER //
// ./src/api/topic/topicExam.js